import Vue from 'vue'
import App from './App.vue'
import './plugins/jquery'
import './plugins/moment'
import './plugins/axios'
// import './plugins/sweetalert'
import './plugins/tippy'
import './plugins/print'
import './plugins/vue_scrollto'
import router from './router'
import store from './store'

import vuetify from './plugins/vuetify';

import "tippy.js/themes/light.css";
import "tippy.js/themes/light-border.css";
import "tippy.js/themes/google.css";
import "tippy.js/themes/translucent.css";

// import 'materialize-css/dist/css/materialize.min.css'


import '@/assets/css/materialize.css'
import '@/assets/css/style-IcoFont.css'
import '@/assets/css/style-FirstStep-01.css'
import '@/assets/css/style-FirstStep-02.css'
// import '@/assets/css/style-FirstStep-login.css'

import '@/assets/css/responsive-FirstStep-01.css'
import '@/assets/css/responsive-FirstStep-02.css'
import '@/assets/css/style-override.css'

// import './plugins/vuetify'

import Roles from "./constants/roles";
Vue.use(Roles);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
